<div class="gw-space-y-6 gw-p-x-large gw-max-w-lg">
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div class="gw-space-y-4">
      <p class="gw-text-text-primary gw-text-base">
        {{
          'features.settings.parameters.mobileBuildManifest.description'
            | translate
        }}
      </p>

      <div class="mobile-build-manifest-field">
        <gatewee-input-v2
          [form]="formGroup"
          controlName="appName"
          [label]="
            'features.settings.parameters.mobileBuildManifest.appName.label'
              | translate
          "
          [placeholder]="
            'features.settings.parameters.mobileBuildManifest.appName.placeholder'
              | translate
          "
          id="mobile-build-manifest-appName"
          type="text"
          [required]="true"
        ></gatewee-input-v2>
      </div>

      <div class="mobile-build-manifest-field">
        <gatewee-input-v2
          [form]="formGroup"
          controlName="slug"
          [label]="
            'features.settings.parameters.mobileBuildManifest.slug.label'
              | translate
          "
          [placeholder]="
            'features.settings.parameters.mobileBuildManifest.slug.placeholder'
              | translate
          "
          id="mobile-build-manifest-slug"
          type="text"
          [required]="true"
        ></gatewee-input-v2>
      </div>

      <div class="mobile-build-manifest-field">
        <gatewee-input-v2
          [form]="formGroup"
          controlName="scheme"
          [label]="
            'features.settings.parameters.mobileBuildManifest.scheme.label'
              | translate
          "
          [placeholder]="
            'features.settings.parameters.mobileBuildManifest.scheme.placeholder'
              | translate
          "
          id="mobile-build-manifest-scheme"
          type="text"
        ></gatewee-input-v2>
      </div>

      <div class="mobile-build-manifest-field">
        <gatewee-input-v2
          [form]="formGroup"
          controlName="androidPackage"
          [label]="
            'features.settings.parameters.mobileBuildManifest.androidPackage.label'
              | translate
          "
          [placeholder]="
            'features.settings.parameters.mobileBuildManifest.androidPackage.placeholder'
              | translate
          "
          id="mobile-build-manifest-androidPackage"
          type="text"
        ></gatewee-input-v2>
      </div>

      <div class="mobile-build-manifest-field">
        <gatewee-input-v2
          [form]="formGroup"
          controlName="iosBundleIdentifier"
          [label]="
            'features.settings.parameters.mobileBuildManifest.iosBundleIdentifier.label'
              | translate
          "
          [placeholder]="
            'features.settings.parameters.mobileBuildManifest.iosBundleIdentifier.placeholder'
              | translate
          "
          id="mobile-build-manifest-iosBundleIdentifier"
          type="text"
        ></gatewee-input-v2>
      </div>

      <div class="mobile-build-manifest-field">
        <gatewee-asset-upload
          [control]="getImageControl('iconUrl')"
          [assetType]="imageConfig['iconUrl'].assetType"
          [aspectRatio]="imageConfig['iconUrl'].aspectRatio"
          [resizeToWidth]="imageConfig['iconUrl'].resizeToWidth"
          [resizeToHeight]="imageConfig['iconUrl'].resizeToHeight"
          [domainId]="domainId"
          [label]="
            'features.settings.parameters.mobileBuildManifest.iconUrl.label'
              | translate
          "
        ></gatewee-asset-upload>
      </div>

      <div class="mobile-build-manifest-field">
        <gatewee-asset-upload
          [control]="getImageControl('splashImageUrl')"
          [assetType]="imageConfig['splashImageUrl'].assetType"
          [aspectRatio]="imageConfig['splashImageUrl'].aspectRatio"
          [transparentSafeAreaRatio]="0.63"
          [resizeToWidth]="imageConfig['splashImageUrl'].resizeToWidth"
          [resizeToHeight]="imageConfig['splashImageUrl'].resizeToHeight"
          [domainId]="domainId"
          [label]="
            'features.settings.parameters.mobileBuildManifest.splashImageUrl.label'
              | translate
          "
        ></gatewee-asset-upload>
      </div>

      <div class="mobile-build-manifest-field">
        <gatewee-input-v2
          [form]="formGroup"
          controlName="splashBackgroundColor"
          [label]="
            'features.settings.parameters.mobileBuildManifest.splashBackgroundColor.label'
              | translate
          "
          [placeholder]="
            'features.settings.parameters.mobileBuildManifest.splashBackgroundColor.placeholder'
              | translate
          "
          id="mobile-build-manifest-splashBackgroundColor"
          type="text"
        ></gatewee-input-v2>
      </div>
    </div>

    <div class="gw-flex gw-justify-end gw-gap-3 gw-mt-6">
      <gatewee-button
        variant="outline"
        [title]="'common.actions.cancel' | translate"
        (clicked)="close()"
        [disabled]="submitting"
      ></gatewee-button>
      <gatewee-button
        variant="primary"
        [title]="'common.actions.save' | translate"
        type="submit"
        [disabled]="submitting || formGroup.invalid"
      ></gatewee-button>
    </div>
  </form>
</div>
